import React, {memo} from 'react';
import { animated, useSpring } from 'react-spring';

function ExpandProjectBox(event: { target: any; }) {
  let ProjectsGrid = event.target.closest("#projects-grid");
  let SelectedProjectBox = event.target.closest(".project-box > div");
  if (SelectedProjectBox !== null) {
    for (let ProjBox of ProjectsGrid.querySelectorAll(".project-box > div")) {
      if (ProjBox !== SelectedProjectBox) {
        ProjBox.classList.remove("expanded");
      }
    }
    SelectedProjectBox.classList.toggle("expanded");
  }
}


function ProjectBox(props: {
                    shortTitle: string,
                    projImg: string,
                    projImgAlt: string,
                    id?: string | null,
                    fadeInDelay?: any | null}) {

  const fadeInStyle = useSpring({
    opacity: 1,
    transform: "translateY(0px)",
    from: { opacity: 0, transform: "translateY(-20px)" },
    delay: props.fadeInDelay
  });
  return (
    <animated.div className="project-box" style={fadeInStyle} onClick={ExpandProjectBox}>
      <h2>{props.shortTitle}</h2>
      <div>
        <div id={props.id}>
          <img src={process.env.PUBLIC_URL + "/project_imgs/" + props.projImg} alt={props.projImgAlt}></img>
        </div>
        <p>{props.shortTitle}</p>
      </div>
    </animated.div>
  );
}

export default memo(ProjectBox);